export function getModuleType(datapool) {
  return datapool.moduleType;
}
